import React from 'react'


interface IIcon {
name:string
src?:boolean
}
export default function Icon(props:IIcon) {
    if(props.src){
        return(
            <img  className="image-icon" src={props.name}/>
        )
    }
    return (
        <i className={"font-icon fa fa-"+props.name}></i>
    )
}
